var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.815746 5.96697L5.5014 1.39947L10.187 5.96697C10.2707 6.04874 10.3831 6.09452 10.5001 6.09452C10.6172 6.09452 10.7296 6.04874 10.8133 5.96697C10.8538 5.92725 10.886 5.87985 10.908 5.82753C10.93 5.77521 10.9413 5.71903 10.9413 5.66229C10.9413 5.60554 10.93 5.54936 10.908 5.49704C10.886 5.44472 10.8538 5.39731 10.8133 5.35759L5.82858 0.497603C5.74105 0.412273 5.62364 0.364523 5.5014 0.364523C5.37915 0.364523 5.26175 0.412273 5.17421 0.497603L0.189547 5.35666C0.148647 5.3964 0.116247 5.44392 0.0940466 5.49642C0.0719466 5.54891 0.0605459 5.60531 0.0605459 5.66229C0.0605459 5.71926 0.0719466 5.77566 0.0940466 5.82815C0.116247 5.88064 0.148647 5.92816 0.189547 5.96791C0.273247 6.04968 0.385646 6.09546 0.502646 6.09546C0.619646 6.09546 0.732046 6.04968 0.815746 5.96791V5.96697Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.23240b1cfb9782acd15364434d3fd1a9.svg";
export { ForwardRef as ReactComponent };